import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationError, getValidationErrors, mapErrors } from 'icreate/common/validators';

@Component({
    selector: 'app-input-select-with-error',
    templateUrl: './input-select-with-error.component.html',
    styleUrls: ['./input-select-with-error.component.css'],
    standalone: false,
})
export class InputSelectWithErrorComponent implements OnInit {
    @Input() initialValue;
    @Input() legend: string;
    @Input() propertyName: string;
    @Input() placeholder: string;
    @Input() validatorFunction;
    @Input() optionsArray: string[];
    @Input() valueKey: string;
    @Input() displayKey: string;
    @Input() maxLength: number;
    @Input() disabled: boolean = false;
    @Input() emitOnInput: boolean = false;
    @Input() removeBackground: boolean = false;
    @Input() extraListInfo: boolean = false;
    @Input() isNumber: boolean = false;

    @Output() onInputUpdated: EventEmitter<any> = new EventEmitter();

    @ViewChild('listContainer') listContainer: ElementRef;
    @ViewChild('listInput') listInput: ElementRef;

    filteredOptionsArray: string[];
    showList: boolean = false;
    inputValue;

    selectedOption: any;

    validationErrors: { [propertyName: string]: ValidationError } = {};

    constructor(private translateService: TranslateService) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.showList &&
            !this.listContainer?.nativeElement.contains(event.target) &&
            !this.listInput?.nativeElement.contains(event.target)
        ) {
            this.showList = !this.showList;
            let found = false;
            this.optionsArray.map(option => {
                if (this.getDisplayValue(option) === this.inputValue) {
                    found = true;
                    const value = this.getOptionValue(option);
                    this.onInputUpdated.emit(value);
                }
            });
            if (!found) this.onInputUpdated.emit(this.inputValue);
        }
    }

    ngOnInit() {
        if (!this.initialValue) {
            this.inputValue = undefined;
        } else {
            this.inputValue = this.getDisplayValue(this.initialValue);
        }
        this.filterList();
        this.showList = false;
    }

    onInput(value: string) {
        this.checkStringError();
        if (this.emitOnInput) {
            this.onInputUpdated.emit(value);
        }
    }

    filterList() {
        if (this.disabled) return;
        this.showList = false;
        if (this.inputValue) {
            this.filteredOptionsArray = this.optionsArray?.filter(option => {
                let input = this.inputValue;
                return this.getDisplayValue(option).toUpperCase().includes(input.toUpperCase());
            });
            this.showList = true;
        } else {
            this.filteredOptionsArray = this.optionsArray;
            this.showList = true;
        }
    }

    optionSelected(item) {
        this.selectedOption = this.getOptionValue(item);
        this.inputValue = this.getDisplayValue(item);
        this.checkInputErrors();
        this.showList = false;
    }

    hasErrorString() {
        return this.propertyName in this.validationErrors;
    }

    getErrorString() {
        if (this.propertyName in this.validationErrors) {
            const err = this.validationErrors[this.propertyName];
            return this.translateService.instant(err.errors[0], err.params);
        }
        return;
    }

    checkStringError() {
        if (this.validatorFunction) {
            const object = {};
            const input = this.isNumber ? Number(this.inputValue) : this.inputValue;
            object[this.propertyName] = input;
            const errors = getValidationErrors(this.validatorFunction, object);

            if (errors) {
                this.validationErrors = mapErrors(errors);
            }
        }
    }

    checkInputErrors(shouldEmit: boolean = true) {
        if (this.validatorFunction) {
            const object = {};
            object[this.propertyName] = this.selectedOption;
            const errors = getValidationErrors(this.validatorFunction, object);

            if (errors) {
                this.validationErrors = mapErrors(errors);
            }
        }
        if (shouldEmit) this.onInputUpdated.emit(this.selectedOption);
    }

    getOptionValue(option) {
        if (this.valueKey) {
            return option[this.valueKey];
        }
        return option;
    }

    getDisplayValue(option) {
        if (this.displayKey) {
            return option[this.displayKey];
        }

        if (this.isNumber) return Number(option).toString();
        return option.toString();
    }

    getNameArray(item) {
        const name = this.getDisplayValue(item);
        if (!this.inputValue) return [name];
        const escapedInput = this.inputValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        const regex = new RegExp(`(${escapedInput})`, 'gi');
        return name.split(regex).filter(val => val.length > 0);
    }

    iconClicked() {
        this.showList = this.disabled ? false : !this.showList;
        let found;
        this.optionsArray.map(option => {
            if (this.getDisplayValue(option) === this.inputValue) {
                found = true;
                const value = this.getOptionValue(option);
                this.onInputUpdated.emit(value);
            }
        });
        if (!found) this.onInputUpdated.emit();
    }
}
